import { render, staticRenderFns } from "./customer_chart_dash.vue?vue&type=template&id=0e60ec6f&scoped=true&"
import script from "./customer_chart_dash.vue?vue&type=script&lang=js&"
export * from "./customer_chart_dash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e60ec6f",
  null
  
)

export default component.exports